/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_Upload_FormatInputs */

const en_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF or DOCX format`)
};

const de_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF- oder DOCX-Format`)
};

const fr_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format PDF ou DOCX`)
};

const es_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato PDF o DOCX`)
};

const it_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato PDF o DOCX`)
};

const nl_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF of DOCX formaat`)
};

const pl_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format PDF lub DOCX`)
};

const fi_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF tai DOCX -muoto`)
};

const da_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF eller DOCX-format`)
};

const sv_onboarding_resume_upload_format = /** @type {(inputs: Onboarding_Resume_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF eller DOCX-format`)
};

/**
* | output |
* | --- |
* | "PDF or DOCX format" |
*
* @param {Onboarding_Resume_Upload_FormatInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_upload_format = /** @type {((inputs?: Onboarding_Resume_Upload_FormatInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Upload_FormatInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_upload_format(inputs)
	if (locale === "fr") return fr_onboarding_resume_upload_format(inputs)
	if (locale === "es") return es_onboarding_resume_upload_format(inputs)
	if (locale === "it") return it_onboarding_resume_upload_format(inputs)
	if (locale === "nl") return nl_onboarding_resume_upload_format(inputs)
	if (locale === "pl") return pl_onboarding_resume_upload_format(inputs)
	if (locale === "fi") return fi_onboarding_resume_upload_format(inputs)
	if (locale === "da") return da_onboarding_resume_upload_format(inputs)
	if (locale === "sv") return sv_onboarding_resume_upload_format(inputs)
	return en_onboarding_resume_upload_format(inputs)
});